import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaHome,
  FaList,
  FaUsers,
  FaFileInvoiceDollar,
  FaCog,
  FaTasks,
  FaChevronDown,
  FaChevronRight,
  FaBriefcase,
  FaUserFriends,
  FaLayerGroup,
  FaClipboardList,
  FaUserTie,
  FaUserShield,
  FaBuilding,
  FaPlus,
  FaSearch,
  FaCogs,
  FaFolder,
  FaClipboard,
} from "react-icons/fa";
import { FaChartColumn, FaChartLine } from "react-icons/fa6";
import "./Menu.css";
import { getJobTitleLabel, getJobTitleLabelPlural } from "../../utils/jobTitleLabel";

export function getMenuList() {
  const jobLabel = getJobTitleLabel();
  const jobPluralLabel = getJobTitleLabelPlural();
  return [
    {
      title: "Dashboard",
      icon: <FaHome className="w-5 h-5" />,
      to: "/dashboard",
      content: [
        { title: "Organisation", icon: <FaChartColumn className="w-4 h-4" />, to: "/dashboard/organisation" },
        { title: jobLabel, icon: <FaChartColumn className="w-4 h-4" />, to: "/dashboard/job" },
        { title: "Comparison", icon: <FaChartLine className="w-4 h-4" />, to: "/dashboard/comparison" },
      ],
    },
    {
      title: "Customer",
      icon: <FaUserShield className="w-5 h-5" />,
      content: [
        { title: "Add Customer", icon: <FaPlus className="w-4 h-4" />, to: "/create-customer" },
        { title: "Customer List", icon: <FaList className="w-4 h-4" />, to: "/customer-list" },
      ],
    },
    {
      title: `${jobLabel} Categories`,
      icon: <FaFolder className="w-5 h-5" />,
      content: [
        { title: `Create ${jobLabel} Category`, icon: <FaPlus className="w-4 h-4" />, to: "/create-category" },
        { title: `${jobLabel} Category List`, icon: <FaList className="w-4 h-4" />, to: "/category-list" },
      ],
    },
    {
      title: "Tasks",
      icon: <FaClipboard className="w-5 h-5" />,
      content: [
        { title: "Create Tasks", icon: <FaPlus className="w-4 h-4" />, to: "/create-task" },
        { title: "Tasks List", icon: <FaList className="w-4 h-4" />, to: "/task-list" },
      ],
    },
    {
      title: "Team",
      icon: <FaUserFriends className="w-5 h-5" />,
      content: [
        { title: "Add Employee", icon: <FaPlus className="w-4 h-4" />, to: "/add-employee" },
        { title: "Employee List", icon: <FaList className="w-4 h-4" />, to: "/employee-list" },
        { title: "Manage Admins", icon: <FaUserTie className="w-4 h-4" />, to: "/admin-list" },
      ],
    },
    {
      title: jobPluralLabel,
      icon: <FaBriefcase className="w-5 h-5" />,
      content: [
        { title: `Create ${jobLabel}`, icon: <FaPlus className="w-4 h-4" />, to: "/create-job" },
        { title: `${jobLabel} List`, icon: <FaList className="w-4 h-4" />, to: "/job-list" },
        { title: `Draft ${jobPluralLabel}`, icon: <FaList className="w-4 h-4" />, to: "/draft-list" },
        { title: `${jobLabel} Activity List`, icon: <FaList className="w-4 h-4" />, to: "/job-activity-list" },
      ],
    },
  ];
}

export const MenuList = getMenuList();

const Menu = () => {
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({});
  const [menuList, setMenuList] = useState(() => getMenuList());

  useEffect(() => {
    const handleLabelUpdate = () => setMenuList(getMenuList());
    window.addEventListener("jobTitleLabelUpdated", handleLabelUpdate);
    return () => window.removeEventListener("jobTitleLabelUpdated", handleLabelUpdate);
  }, []);

  const toggleSubmenu = (title) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  return (
    <div className="menu-container">
      <div className="menu-scroll">
        {menuList.map((menu, index) => (
          <div key={index} className="menu-item">
            {menu.content ? (
              <div className="submenu-container">
                <button
                  className={`menu-link ${expandedMenus[menu.title] ? "active" : ""}`}
                  onClick={() => toggleSubmenu(menu.title)}
                >
                  <span className="menu-icon">{menu.icon}</span>
                  <span className="menu-title">{menu.title}</span>
                  <span className="submenu-arrow">
                    {expandedMenus[menu.title] ? (
                      <FaChevronDown className="w-3 h-3" />
                    ) : (
                      <FaChevronRight className="w-3 h-3" />
                    )}
                  </span>
                </button>
                <div
                  className={`submenu ${expandedMenus[menu.title] ? "show" : ""}`}
                >
                  {menu.content.map((submenu, subIndex) => (
                    <Link
                      key={subIndex}
                      to={submenu.to}
                      className={`submenu-link ${location.pathname === submenu.to ? "active" : ""}`}
                    >
                      <span className="submenu-icon">{submenu.icon}</span>
                      <span className="submenu-title">{submenu.title}</span>
                    </Link>
                  ))}
                </div>
              </div>
            ) : (
              <Link
                to={menu.to}
                className={`menu-link ${location.pathname === menu.to ? "active" : ""}`}
              >
                <span className="menu-icon">{menu.icon}</span>
                <span className="menu-title">{menu.title}</span>
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Menu;
